'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.FadeIn = void 0;
const $ = require("jquery");
class FadeIn {
    constructor() {
        //画面をスクロールするとイベントが発動する
        $(window).scroll(function () {
            //スクロールバーの位置を取得
            const scroll = $(window).scrollTop();
            //ウィンドウの高さを取得
            const windowHeight = $(window).height();
            //出現範囲
            const elemPos01 = $('#poster').offset().top;
            const contentHeight = $('#poster').outerHeight(true);
            //指定の範囲内でフェードイン
            if (scroll + (windowHeight / 2) >= elemPos01) {
                if (scroll + windowHeight < elemPos01 + contentHeight) {
                    $('.buy-button').attr('data-is-show', 'true');
                }
                else {
                    $('.buy-button').attr('data-is-show', 'false');
                }
            }
            else {
                $('.buy-button').attr('data-is-show', 'false');
            }
            //フェードインさせたい要素の縦位置を取得
            const elemPos02 = $('.interview').offset().top;
            //要素がウィンドウの中に入ったら要素をフェードインする
            if (scroll > elemPos02 - windowHeight) {
                $('.to-top').attr('data-is-show', 'true');
            }
            else {
                $('.to-top').attr('data-is-show', 'false');
            }
        });
    }
}
exports.FadeIn = FadeIn;
exports.default = FadeIn;
